// src/pages/HomeView/components/EfficiencyDataTab.tsx
import React from 'react';
import { EfficiencyReport } from './EfficiencyReport/EfficiencyReport';

export const EfficiencyDataTab: React.FC = () =>
{
  return (
    <div className="efficiency-data-tab-content flex-1 overflow-y-auto">
      <EfficiencyReport />
    </div>
  );
};
